import * as React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionDetailsProps,
  AccordionProps,
  AccordionSummary,
  AccordionSummaryProps,
  Button,
  ButtonProps,
  CircularProgress,
  Box,
  Container,
  ContainerProps,
  IconButton,
  IconButtonProps,
  InputAdornment,
  List,
  ListItem,
  ListItemButton,
  ListItemButtonProps,
  ListItemIcon,
  ListItemIconProps,
  Modal,
  ModalProps,
  Stack,
  CircularProgressProps,
  StackProps,
  TextField,
  TextFieldProps,
  ListProps,
  ListItemProps,
  ListItemTextProps,
  ListItemText,
  TextareaAutosize,
  TextareaAutosizeProps,
  Tabs,
  TabsProps,
  Tab,
  TabProps,
  SliderProps,
  Slider,
  FormControlLabelProps,
  FormControlLabel,
  CheckboxProps,
  Checkbox,
  Select,
  SelectProps,
  MenuItem,
  MenuItemProps,
  Menu,
  Radio,
  RadioProps,
  InputLabel,
  InputLabelProps,
  FormControl,
  FormControlProps,
  DialogProps,
  Dialog,
  DialogContent,
  DialogContentProps,
  BoxProps,
  Tooltip,
  TooltipProps,
  Chip,
  ChipProps,
  TypographyProps,
  Typography,
  CardProps,
  Card,
  CardHeaderProps,
  CardHeader,
  CardContentProps,
  CardContent,
  CardActionsProps,
  CardActions,
  Avatar,
  AvatarProps,
  Paper,
  PaperProps,
  InputBase,
  InputBaseProps,
  CardMediaProps,
  CardMedia,
  ListItemAvatar,
  ListItemAvatarProps,
  CollapseProps,
  Collapse,
  MenuProps,
  DialogTitleProps,
  DialogTitle,
  DialogContentTextProps,
  DialogContentText,
  DialogActionsProps,
  DialogActions,
  SnackbarProps,
  Snackbar,
  Skeleton,
  SkeletonProps,
  Divider,
  DividerProps,
} from '@mui/material';

import {
  TabContext,
  TabContextProps,
  TabList,
  TabListProps,
  TabPanel,
  TabPanelProps,
} from '@mui/lab';

import style from './wrapper.module.scss';
import { LoadingButton } from '@mui/lab';
import { LoadingButtonProps } from '@mui/lab/LoadingButton';

type IContainer = {} & ContainerProps;
export const WContainer = (props: IContainer) => {
  return <Container {...props}> {props.children}</Container>;
};

type IMuiList = {} & ListProps;
export const WList = (props: IMuiList) => {
  return (
    <List
      sx={{
        p: 0,
        '.MuiListItemIcon-root': {
          minWidth: 36,
        },
        '.MuiListItemButton-root': {
          borderRadius: '6px',
          marginBottom: '4px',
        },
      }}
      {...props}
    >
      {props.children}
    </List>
  );
};
type IMuiListItemButton = {} & ListItemButtonProps;
export const WListItemButton = (props: IMuiListItemButton) => {
  return <ListItemButton {...props}>{props.children} </ListItemButton>;
};

type IMuiListItem = {} & ListItemProps;
export const WListItem = (props: IMuiListItem) => {
  return <ListItem {...props}>{props.children} </ListItem>;
};

type IMuiListItemIcon = {} & ListItemIconProps;
export const WListItemIcon = (props: IMuiListItemIcon) => {
  return <ListItemIcon {...props}>{props.children} </ListItemIcon>;
};

type IMuiListItemText = {} & ListItemTextProps;
export const WListItemText = (props: IMuiListItemText) => {
  return <ListItemText {...props}>{props.children} </ListItemText>;
};

type IMuiTextField = {
  suffix?: React.ReactNode;
  prefix?: React.ReactNode | any;
} & TextFieldProps;
export const WTextField = (props: IMuiTextField) => {
  return (
    <div className={style['text-field-wrapper']}>
      {props.prefix && <div className={style['prefix']}>{props.prefix}</div>}
      <TextField
        {...props}
        className={style['text-field']}
        sx={{
          '& fieldset': { borderColor: 'var(--border-color)' },
          '&:focus-within fieldset, &:focus-visible fieldset': {
            border: '1px solid #000!important',
          },
        }}
      />
      {props.suffix && <div className={style['suffix']}>{props.suffix}</div>}
    </div>
  );
};

type IMuiButton = {} & ButtonProps;
export const WButton = (props: IMuiButton) => {
  return (
    <Button className={style['button']} variant={props.variant || 'outlined'} {...props}>
      {props.children}
    </Button>
  );
};

type IMuiLoadingButton = {} & LoadingButtonProps;
export const WLoadingButton = (props: IMuiLoadingButton) => {
  return (
    <LoadingButton className={style['button']} variant={props.variant || 'outlined'} {...props}>
      {props.children}
    </LoadingButton>
  );
};

type IMuiModal = {} & ModalProps;
export const WModal = React.forwardRef<HTMLDivElement, IMuiModal>((props, ref) => {
  return (
    <Modal {...props}>
      <div ref={ref}>{props.children}</div>
    </Modal>
  );
});

type IIconButton = {} & IconButtonProps;
export const WIconButton = (props: IIconButton) => {
  return <IconButton {...props}>{props.children}</IconButton>;
};

type IAccordion = {
  newSx?: any;
} & AccordionProps;
export const WAccordion = (props: IAccordion) => {
  const { newSx, ...newProps } = props;
  return (
    <Accordion sx={newSx} {...newProps}>
      {props.children}
    </Accordion>
  );
};

type IAccordionSummary = {
  expandIcon?: React.ReactNode;
} & AccordionSummaryProps;
export const WAccordionSummary = (props: IAccordionSummary) => {
  return (
    <AccordionSummary {...props} expandIcon={props.expandIcon}>
      {props.children}
    </AccordionSummary>
  );
};

type ICollapse = {} & CollapseProps;
export const WCollapse = (props: ICollapse) => {
  return <Collapse {...props}>{props.children}</Collapse>;
};

type IAccordionDetails = {} & AccordionDetailsProps;
export const WAccordionDetails = (props: IAccordionDetails) => {
  return <AccordionDetails {...props}>{props.children}</AccordionDetails>;
};

type IMuiStack = {} & StackProps;
export const WStack = (props: IMuiStack) => {
  return <Stack {...props}>{props.children} </Stack>;
};

type ITextareaAutosize = {
  maxRows?: number;
} & TextareaAutosizeProps;
export const WTextareaAutosize = (props: ITextareaAutosize) => {
  return <TextareaAutosize maxRows={props.maxRows} {...props} />;
};

type ICircularProgress = {} & CircularProgressProps;
export const WCircularProgress = (props: ICircularProgress) => {
  return <CircularProgress {...props} />;
};

type ITabContext = {} & TabContextProps;
export const WTabContext = (props: ITabContext) => {
  return <TabContext {...props} />;
};

type ITabs = { displayIndicator?: boolean } & TabsProps;
export const WTabs = (props: ITabs) => {
  return (
    <Tabs
      sx={{
        '.MuiTabs-indicator': {
          display: props.displayIndicator ? '' : 'none',
        },
      }}
      {...props}
    />
  );
};

type ITab = {} & TabProps;
export const WTab = (props: ITab) => {
  return <Tab {...props} />;
};

type ITabPanel = {} & TabPanelProps;
export const WTabPanel = (props: ITabPanel) => {
  return <TabPanel {...props} />;
};

type ISlider = {} & SliderProps;
export const WSlider = (props: ISlider) => {
  return <Slider {...props} />;
};

type ICheckbox = {} & CheckboxProps;
export const WCheckbox = (props: ICheckbox) => {
  return <Checkbox {...props} />;
};

type IFormControlLabel = {} & FormControlLabelProps;
export const WFormControlLabel = (props: IFormControlLabel) => {
  return <FormControlLabel {...props} />;
};

type IMenu = {} & MenuProps;
export const WMenu = (props: IMenu) => {
  return <Menu {...props} />;
};

type ITypography = {} & TypographyProps;
export const WTypography = (props: ITypography) => {
  return <Typography {...props}>{props.children}</Typography>;
};

type ICardActions = {} & CardActionsProps;
export const WCardActions = (props: ICardActions) => {
  return <CardActions {...props}>{props.children}</CardActions>;
};

type ICardContent = {} & CardContentProps;
export const WCardContent = (props: ICardContent) => {
  return <CardContent {...props}>{props.children}</CardContent>;
};

type ICardHeader = {} & CardHeaderProps;
export const WCardHeader = (props: ICardHeader) => {
  return <CardHeader {...props} />;
};
type IAvatar = {} & AvatarProps;
export const WAvatar = (props: IAvatar) => {
  return <Avatar {...props}>{props.children}</Avatar>;
};

type ICard = {} & CardProps;
export const WCard = (props: ICard) => {
  return <Card {...props}>{props.children}</Card>;
};

type ICardMedia = {
  comp: any;
} & CardMediaProps;
export const WCardMedia = (props: ICardMedia) => {
  const { comp, ...newProps } = props;
  return (
    <CardMedia component={comp} {...newProps}>
      {props.children}
    </CardMedia>
  );
};

type ISelect = {} & SelectProps;
export const WSelect = (props: ISelect) => {
  return (
    <Select
      {...props}
      sx={{
        '& fieldset': { borderColor: 'var(--border-color)' },
        '&:focus-within fieldset, &:focus-visible fieldset': {
          border: '1px solid #000!important',
        },
      }}
    />
  );
};

type IMenuItem = {} & MenuItemProps;
export const WMenuItem = (props: IMenuItem) => {
  return <MenuItem {...props} />;
};

type IRadio = {} & RadioProps;
export const WRadio = (props: IRadio) => {
  return <Radio {...props} />;
};

type IInputLabel = {} & InputLabelProps;
export const WInputLabel = (props: IInputLabel) => {
  return <InputLabel {...props} />;
};

type IFormControl = {} & FormControlProps;
export const WFormControl = (props: IFormControl) => {
  return <FormControl {...props} />;
};
type IDialog = {} & DialogProps;
export const WDialog = (props: IDialog) => {
  return <Dialog {...props}>{props.children}</Dialog>;
};

type IDialogContent = {} & DialogContentProps;
export const WDialogContent = (props: IDialogContent) => {
  return <DialogContent {...props}>{props.children}</DialogContent>;
};

type IBox = {
  width?: any;
  height?: number;
  padding?: string;
  position?: string;
  top?: number;
  left?: number;
  bottom?: number;
  right?: number;
  zIndex?: number;
  background?: string;
  transform?: string;
} & BoxProps;
export const WBox = (props: IBox) => {
  return (
    <Box
      {...props}
      sx={{
        width: props.width,
        height: props.height,
        padding: props.padding,
        position: props.position,
        top: props.top,
        left: props.left,
        bottom: props.bottom,
        right: props.right,
        zIndex: props.zIndex,
        background: props.background,
        transform: props.transform,
        flexDirection: props.flexDirection,
      }}
    >
      {props.children}
    </Box>
  );
};

type ITooltip = {} & TooltipProps;
export const WTooltip = (props: ITooltip) => {
  return <Tooltip {...props} />;
};

type IChip = {} & ChipProps;
export const WChip = (props: IChip) => {
  return <Chip {...props} />;
};

type IPaper = {
  comp?: any;
} & PaperProps;

export const WPaper = (props: IPaper) => {
  const { comp, ...muiPaperProps } = props;

  return (
    <Paper component={comp} {...muiPaperProps}>
      {props.children}
    </Paper>
  );
};

type IInputBase = {} & InputBaseProps;
export const WInputBase = (props: IInputBase) => {
  return <InputBase {...props} />;
};
type IListItemAvatar = {} & ListItemAvatarProps;
export const WListItemAvatar = (props: IListItemAvatar) => {
  return <ListItemAvatar {...props}>{props.children}</ListItemAvatar>;
};

type ITabList = {} & TabListProps;
export const WTabList = (props: ITabList) => {
  return <TabList {...props}>{props.children}</TabList>;
};

type IDialogTitle = {} & DialogTitleProps;
export const WDialogTitle = (props: IDialogTitle) => {
  return <DialogTitle {...props}>{props.children}</DialogTitle>;
};

type IDialogContentText = {} & DialogContentTextProps;
export const WDialogContentText = (props: IDialogContentText) => {
  return <DialogContentText {...props}>{props.children}</DialogContentText>;
};

type IDialogActions = {} & DialogActionsProps;
export const WDialogActions = (props: IDialogActions) => {
  return <DialogActions {...props}>{props.children}</DialogActions>;
};

type ISnackbar = {} & SnackbarProps;
export const WSnackbar = (props: ISnackbar) => {
  return <Snackbar {...props}>{props.children}</Snackbar>;
};

type ISkeleton = {} & SkeletonProps;
export const WSkeleton = (props: ISkeleton) => {
  return <Skeleton {...props}>{props.children}</Skeleton>;
};

type IDivider = {} & DividerProps;
export const WDivider = (props: IDivider) => {
  return <Divider {...props}>{props.children}</Divider>;
};
